import React from "react";
import { GlobeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ContentIcon } from "../ContentIcon";
import { heroIncludes } from "../../data/content";
import { MOCKUP_URL } from "../../data/offer";
export function Hero() {
  return <header data-id="element-211" data-mp="hv7hddkf0t1u">
      <div className="bg-sun px-4 py-2.5 text-center text-[13px] font-black uppercase tracking-wide text-navy sm:text-sm" data-id="element-212" data-mp="hvqsaabneh6d">
        Special Introductory Offer — Complete Collection for Just $27 USD
      </div>

      <section className="bg-brand-soft px-4 pb-14 pt-8 sm:pt-12" data-id="element-213" data-mp="qu2s92yemrbh">
        <div className="mx-auto max-w-4xl text-center" data-id="element-214" data-mp="vm2jm70esbwg">
          <p className="text-sm font-black uppercase tracking-wide text-brand" data-id="element-215" data-mp="voor66naureo">
            Autism Communication Support Blueprint™
          </p>
          <h1 className="mt-3 text-balance text-[2.15rem] font-black leading-[1.08] text-navy sm:text-5xl lg:text-6xl" data-id="element-216" data-mp="15lbed233lujv">
            Help Autistic Children Communicate With{" "}
            <span className="bg-sun px-1.5 leading-[1.3] [box-decoration-break:clone]" data-id="element-217" data-mp="9njb4dqh2id9">Greater Confidence</span>{" "}
            — One Practical Support at a Time
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg font-semibold leading-relaxed text-ink/80 sm:text-xl" data-id="element-218" data-mp="4r2j38g5jjuw">
            A Structured, Visual Communication Planning System for Speech-Language Pathologists, Special
            Educators & Communication Support Professionals
          </p>

          <img src={MOCKUP_URL} alt="Autism Communication Support Blueprint: 6 volumes and 5 bonus workbooks" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-219" data-mp="sgep5zg6nbsz" />

          <div className="mt-6 rounded-3xl bg-navy px-5 py-6 text-left sm:px-8" data-id="element-220" data-mp="imehpqxfhuh3">
            <p className="text-xl font-black uppercase leading-snug text-sun sm:text-2xl" data-id="element-221" data-mp="emng0s6d5txs">
              Stop spending hours searching for visual communication resources and wondering what to plan next.
            </p>
            <p className="mt-3 text-base font-semibold leading-relaxed text-white/85 sm:text-lg" data-id="element-222" data-mp="16c8pvv6syuv0">
              Organize individualized communication supports with a practical, step-by-step educational system
              designed to help you identify communication opportunities, prepare visual resources, support
              meaningful interactions, and collaborate with families and educators.
            </p>
            <p className="mt-4 text-sm font-semibold text-white/70" data-id="element-223" data-mp="2hvfrwpcoyfku">
              Created by Dr. Elena Martins, educational author persona specializing in AAC and communication
              support resources.
            </p>
          </div>

          <div className="mt-6 rounded-3xl bg-white p-5 text-left shadow-[0_10px_30px_rgba(14,37,87,0.08)] sm:p-8" data-id="element-224" data-mp="27yjp909h4no7">
            <h2 className="text-balance text-center text-xl font-black leading-snug text-navy sm:text-2xl" data-id="element-225" data-mp="2cwl8bl6wgmzo">
              Everything You Need to Organize Your Communication Support Planning in One Place
            </h2>
            <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-226" data-mp="b2lyl49fedp3">
              {heroIncludes.map(item => <li key={item.label} className="flex items-center gap-3 rounded-xl bg-brand-soft p-3" data-id="element-227" data-mp="1vko6f9eg56hp">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand text-white" data-id="element-228" data-mp="25ctuw95hp5s5">
                    <ContentIcon name={item.icon} className="h-5 w-5" data-id="element-229" data-mp="20llir5crz6ba" />
                  </span>
                  <span className="text-[15px] font-extrabold leading-snug text-navy" data-id="element-230" data-mp="2ecz0cdr4hu3o">{item.label}</span>
                </li>)}
            </ul>
          </div>

          <p className="mt-8 text-2xl font-black uppercase text-navy sm:text-3xl" data-id="element-231" data-mp="2ae9cfr8gku5s">
            Get the complete collection for just <span className="text-cta" data-id="element-232" data-mp="2jcuwjqtkwh8o">$27</span>
          </p>
          <div className="mt-5" data-id="element-233" data-mp="2jaidtbfzy2uk">
            <CtaButton id="first-cta" label="Yes! I want the Autism Communication Support Blueprint™" sub="Instant Digital Access · One-Time Payment of $27 · Lifetime Access to Purchased Materials" data-id="element-234" data-mp="txevkypt61tv" />
          </div>

          <div className="mt-8" data-id="element-235" data-mp="qhtz83opdqxg">
            <Countdown label="Your special offer ends in:" data-id="element-236" data-mp="veauriy8f7kk" />
          </div>

          <p className="mx-auto mt-6 flex max-w-md items-start justify-center gap-2 text-sm font-bold text-ink/70" data-id="element-237" data-mp="10dx9jwtpkvvh">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-238" data-mp="15cqf932r7il3" />
            Your checkout will automatically display the applicable currency and final purchase amount.
          </p>
          <p className="mt-2 text-xs font-semibold text-ink/55" data-id="element-239" data-mp="cnt2tgl84g09">
            Educational resources designed to complement individualized professional assessment and planning.
          </p>
        </div>
      </section>
    </header>;
}